import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";

export default function PaymentCancelPage() {
  const nav = useNavigate();
  return (
    <Layout>
      <div data-testid="payment-cancel-page" className="max-w-lg mx-auto text-center py-16">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#A39A8E] mb-2">— Checkout cancelled</p>
        <h1 className="font-head text-3xl text-[#EBE5D9] mb-4">No worries — nothing was charged.</h1>
        <p className="text-[#A39A8E] mb-8 text-sm">
          You can come back to the pricing page anytime you&apos;re ready.
        </p>
        <div className="flex gap-3 justify-center">
          <button onClick={() => nav("/pricing")} className="bg-[#CFA66A] text-[#0F0E0C] font-medium px-6 py-2.5 rounded-sm hover:bg-[#EBE5D9] font-mono text-xs uppercase tracking-widest">Back to pricing</button>
          <button onClick={() => nav("/today")} className="bg-transparent border border-[#2E2A25] text-[#EBE5D9] hover:bg-[#26231F] px-6 py-2.5 rounded-sm font-mono text-xs uppercase tracking-widest">Keep journaling</button>
        </div>
      </div>
    </Layout>
  );
}
